export default __webpack_public_path__ + "c45ff4889526375d32314844d0b67d8a.png";